import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeadland = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	id: "turn-around-down-direction",
	"data-name": "Flat Color",
	xmlns: "http://www.w3.org/2000/svg",
	className: "icon flat-color",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "primary",
		d: "M18.71,17.29a1,1,0,0,0-1.42,0L16,18.59V7.5a5.5,5.5,0,0,0-11,0V20a1,1,0,0,0,2,0V7.5a3.5,3.5,0,0,1,7,0V18.59l-1.29-1.3a1,1,0,0,0-1.42,1.42l3,3a1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,18.71,17.29Z"
	})
});
export default SvgHeadland;
